import { styled } from '@mui/styles';

type WrapperProps = {
  theme: any;
};

export const SvgCircleWithPctWrapper = styled('svg')(({ theme }: WrapperProps) => ({
  maxHeight: '300px',
  margin: '16px auto',
  display: 'block',
  [theme.breakpoints.between('sm', 'lg')]: {
    maxHeight: '200px'
  }
}));

export const RootWrapper = styled('div')(({ theme }: WrapperProps) => ({
  position: 'relative'
}));
